export default {"src":"/_next/static/media/iot-devices.0075785c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};